
import Vue from 'vue'
import { mapper } from '@/stores/store'
import UndoButton from '@/components/IconButtons/UndoButton.vue'
import RandomizeButton from '@/components/IconButtons/RandomizeButton.vue'
import MoveButton from '@/components/IconButtons/MoveButton.vue'
import RotateButton from '@/components/IconButtons/RotateButton.vue'
import ScaleButton from '@/components/IconButtons/ScaleButton.vue'
import ColorPickerButton from '@/components/IconButtons/ColorPickerButton.vue'
import ArrowButton from '@/components/IconButtons/ArrowButton.vue'
import EyeButton from '@/components/IconButtons/EyeButton.vue'
import RectangleButton from '@/components/Buttons/RectangleButton.vue'
import PickedLabel from '@/components/PickedLabel.vue'
import Joystick from '@/components/Joystick.vue'
import { Categories } from '@/constants/elements'

export default Vue.extend({
  components: {
    UndoButton,
    RandomizeButton,
    MoveButton,
    RotateButton,
    ScaleButton,
    ColorPickerButton,
    ArrowButton,
    RectangleButton,
    PickedLabel,
    Joystick,
    EyeButton,
  },
  computed: {
    ...mapper([
      'isLandscape',
      'isDesktop',
      'controlsScale',
      'isTablet',
      'activeCategory',
      'moving',
      'scaling',
      'rotating',
      'pickingColor',
      'downloading',
      'colorPickerSupported',
    ]),
    ...mapper('pin', [
      'color',
      'visible',
      'hasAssets',
      'assetsLength',
      'selectedAsset',
      'undoCount',
    ]),
    isBackgroundFeature(): boolean {
      return this.activeCategory === Categories.BACKGROUND
    },
    currentAssetName(): string[] {
      return this.isBackgroundFeature
        ? [' ', '']
        : this.visible
        ? [
            `${(this.selectedAsset + 1).toString().padStart(2, '0')}/`,
            `${this.assetsLength.toString().padStart(2, '0')}`,
          ]
        : [`${this.$t('gen_hidden')}`, '']
    },
    buttonSize(): string {
      return this.isDesktop ? 'xlg' : 'lg'
    },
  },
  methods: {
    ...mapper(['setMoving', 'setRotating', 'setScaling', 'setPickingColor', 'setCategoryMenuOpen']),
    ...mapper('pin', [
      'randomizePin',
      'nextAsset',
      'prevAsset',
      'toggleAsset',
      'downloadPin',
      'saveUndoState',
      'undo',
    ]),
    saveAndRandomize() {
      this.saveUndoState()
      this.randomizePin()
    },
    onAssetNameClick() {
      if (!this.visible) this.toggleAsset()
    },
  },
})
